query GetMeetIntegration {
    loggedInUser {
        id
        googleMeetIntegration {
            isEnabledCalendarSync
            isEnabledMeetSync
            email
        }
    }
}
